"use client";

import { useEffect, useState } from "react";

const Counter = () => {
	const [remainingTime, setRemainingTime] = useState({
		hours: "",
		minutes: "",
		seconds: "",
	});

	const calculateRemainingTime = () => {
		const currentTime = new Date();
		// Calculate the offset between PST and UTC timezones in minutes
		const pstOffset = -8 * 60;
		const currentTimePST = new Date(currentTime.getTime() + pstOffset * 60 * 1000);

		// Set 8 AM PST as the target time for the current day
		const targetTimePST = new Date(currentTimePST);
		targetTimePST.setUTCHours(7, 0, 0, 0);

		// If the target time is already in the past , we add a day to the target time
		if (targetTimePST.getTime() < currentTimePST.getTime()) {
			targetTimePST.setDate(targetTimePST.getDate() + 1);
		}

		const timeDiff = targetTimePST.getTime() - currentTimePST.getTime();
		const hoursLeft = Math.floor(timeDiff / (1000 * 60 * 60));
		const minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
		const secondsLeft = Math.floor((timeDiff % (1000 * 60)) / 1000);

		setRemainingTime({
			hours: hoursLeft.toString().padStart(2, "0"),
			minutes: minutesLeft.toString().padStart(2, "0"),
			seconds: secondsLeft.toString().padStart(2, "0"),
		});
	};

	useEffect(() => {
		const timer = setInterval(calculateRemainingTime, 1000);
		calculateRemainingTime();

		return () => clearInterval(timer);
	}, []);

	return (
		<>
			<div className="flex items-center justify-center gap-2 text-brand-primary">
				<span className="flex h-12 w-12 items-center justify-center rounded-md border bg-brand-primary/5 text-2xl font-semibold ">
					{remainingTime.hours}
				</span>
				<span>:</span>
				<span className="flex h-12 w-12 items-center justify-center rounded-md border bg-brand-primary/5 text-2xl font-semibold">
					{remainingTime.minutes}
				</span>
				<span>:</span>
				<span className="flex h-12 w-12 items-center justify-center rounded-md border bg-brand-primary/5 text-2xl font-semibold">
					{remainingTime.seconds}
				</span>
			</div>
		</>
	);
};

export default Counter;
